const UNAUTHORIZED = 2001
const checkResp = function (resp) {
  if (resp && (resp.code === 0 || resp.code === 1 || resp.code === UNAUTHORIZED)) {
    return resp.data
  }
  return Promise.reject(resp)
}

export default {
  install (Vue) {
    Vue.checkResp = checkResp
    Object.defineProperty(Vue.prototype, '$checkResp', {value: checkResp})
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/checkResp.js